import { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Sidebar, MobileMenuButton } from './Sidebar';
import { Toaster } from 'sonner';
import ForceChangePassword from '../../pages/ForceChangePassword';
import { BrandLogo } from '../BrandLogo';

export const AppLayout = () => {
    const { user, loading } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
        return localStorage.getItem('macesuite_sidebar_collapsed') === 'true';
    });

    const toggleSidebarCollapsed = () => {
        setSidebarCollapsed((current) => {
            const next = !current;
            localStorage.setItem('macesuite_sidebar_collapsed', String(next));
            return next;
        });
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-[#2F8FCB] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                    <p className="text-slate-600">Loading MaceSuite...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (user.must_change_password) {
        return <ForceChangePassword />;
    }

    return (
        <div className="app-layout">
            <Sidebar
                isOpen={sidebarOpen}
                isCollapsed={sidebarCollapsed}
                onClose={() => setSidebarOpen(false)}
                onToggleCollapse={toggleSidebarCollapsed}
            />
            
            <main className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
                {/* Top bar for mobile */}
                <div className="md:hidden sticky top-0 z-30 bg-white border-b border-slate-200 px-4 py-3">
                    <div className="flex items-center justify-between">
                        <MobileMenuButton onClick={() => setSidebarOpen(true)} />
                        <BrandLogo
                            className="mobile-brand-wordmark"
                            imgClassName="mobile-brand-wordmark-img"
                        />
                        <div className="w-10" />
                    </div>
                </div>

                {/* Page content */}
                <div className="page-canvas p-4 md:p-6 lg:p-8">
                    <Outlet />
                </div>
            </main>

            <Toaster position="top-right" richColors />
        </div>
    );
};
